import {Pipe} from "@angular/core";
import {KompaktdarstellungPipe} from "../kompakt-darstellung.pipe";
import {FormatConfigService} from "../../../core/services/format-config.service";
import {PlatformLocation} from "@angular/common";
import {ComponentLocationStrategy} from "../../services/location-strategy/component-location-strategy";
import {TranslateNamePipe} from "../../pipes/simple/translate-name.pipe";
import {BenutzerListEntry} from "../../../core/gb-api";

@Pipe({
  name: 'kompaktBenutzer'
})
export class KompaktBenutzerPipe extends KompaktdarstellungPipe<BenutzerListEntry> {

  constructor(protected formatConfigService: FormatConfigService, protected location: PlatformLocation,
              protected kompaktLocation: ComponentLocationStrategy, private translateName: TranslateNamePipe) {
    super(formatConfigService, 'BENUTZER', location, kompaktLocation);
  }

  transform(user: BenutzerListEntry): string {
    if (!user) {
      return '';
    }
    if (this.formatElement === 'BENUTZER_TYP00') {
      return [user.userName, user.userVorname, user.userId].filter(val => val).join(' ');
    }
    if (this.formatElement === 'BENUTZER_TYP01') {
      return [this.translateName.transform(user.funktionCode.text), user.userName, user.userVorname].filter(val => val).join(' ');
    }

  }

}
